import type { ApolloError } from '@apollo/client';
import { useCallback } from 'react';

import { toast } from '@/common/components/shared/toaster/toast';
import { useSendInvitationEmailsMutation } from '@/common/graphql';
import { ApiUtils } from '@/common/utils';

export const useResendEmailInvitation = () => {
  const [sendMail, { loading }] = useSendInvitationEmailsMutation();

  const resendEmail = useCallback(
    async ({ ids }: { ids: string[] }) => {
      await sendMail({
        variables: {
          input: {
            employeeIds: ids,
          },
        },
        onCompleted: () => toast.success(),
        onError: (error: ApolloError) => ApiUtils.handleApiError(error),
      });
    },
    [sendMail],
  );

  return { resendEmail, resendLoading: loading };
};
